(function () {
  var bar = document.querySelector('[data-elv-sticky]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var form = document.getElementById(bar.getAttribute('data-form'));
  if (!form) return;
  var mainBtn = form.querySelector('[data-add-to-cart]');
  if (!mainBtn) return;
  var section = form.closest('.product-section') || document;
  var priceSrc = section.querySelector('[data-product-price]');
  var barBtn = bar.querySelector('button');
  var barText = bar.querySelector('[data-elv-sticky-text]');
  var barPrice = bar.querySelector('[data-elv-sticky-price]');
  var focusables = bar.querySelectorAll('a, button');

  function sync() {
    barBtn.disabled = mainBtn.disabled;
    var label = mainBtn.textContent.replace(/\s+/g, ' ').trim();
    if (label) barText.textContent = label;
    if (priceSrc && barPrice) {
      var price = priceSrc.textContent.replace(/\s+/g, ' ').trim();
      if (price) barPrice.textContent = price;
    }
  }

  function setVisible(show) {
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    for (var i = 0; i < focusables.length; i++) {
      focusables[i].tabIndex = show ? 0 : -1;
    }
  }

  var watch = { attributes: true, childList: true, subtree: true, characterData: true };
  new MutationObserver(sync).observe(mainBtn, watch);
  if (priceSrc) new MutationObserver(sync).observe(priceSrc, watch);

  new IntersectionObserver(function (entries) {
    var e = entries[0];
    setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
    // The root is stretched far below the viewport, so "not intersecting" only ever means the
    // button is above it. Without this, a jump (anchor link, fast fling) from below the fold to
    // past the button never crossed the viewport and the bar stayed hidden.
  }, { rootMargin: '0px 0px 100000px 0px' }).observe(mainBtn);

  bar.hidden = false;
  sync();
})();
